import { render, staticRenderFns } from "./VoiceHintBar.vue?vue&type=template&id=fe146e30&scoped=true&"
import script from "./VoiceHintBar.vue?vue&type=script&lang=js&"
export * from "./VoiceHintBar.vue?vue&type=script&lang=js&"
import style0 from "./VoiceHintBar.vue?vue&type=style&index=0&id=fe146e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe146e30",
  null
  
)

export default component.exports